<template>
    <el-dialog
        :title="isForm ? (roleId ? '修改字典数据' : '添加字典数据') : '查看'"
        :close-on-click-modal="false"
        width="640px"
        :model-value="modelValue"
        @close="closed"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 540px">
            <el-form-item label="字典类型" prop="dict_code">
                <el-input v-if="isForm" v-model="formData.dict_code" :disabled="!!props.dictDataCode"></el-input>
                <span v-else>{{ formData.dict_code }}</span>
            </el-form-item>
            <el-form-item label="数据标签" prop="label">
                <el-input v-if="isForm" v-model="formData.label"></el-input>
                <span v-else>{{ formData.label }}</span>
            </el-form-item>
            <el-form-item label="数据键值" prop="value">
                <el-input v-if="isForm" v-model="formData.value" :disabled="formData.preset"></el-input>
                <span v-else>{{ formData.value }}</span>
            </el-form-item>
            <el-form-item label="样式属性" prop="css_class">
                <el-input v-if="isForm" v-model="formData.css_class"></el-input>
                <span v-else>{{ formData.css_class }}</span>
            </el-form-item>
            <el-form-item label="显示排序" prop="list_order">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    :min="0"
                    :max="999999"
                    type="number"
                    controls-position="right"
                ></el-input-number>
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>

            <el-form-item label="回显样式">
                <el-select v-model="formData.list_class" clearable placeholder="回显样式">
                    <el-option v-for="item in classOptions" :key="item.value" :label="item.label" :value="item.value">
                        <el-text v-if="item.value === 'default'">{{ item.label }}</el-text>
                        <el-tag :type="item.value" v-else>{{ item.label }}</el-tag>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">正常</el-radio>
                    <el-radio :value="0">停用</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addDictData, getDictDataDetail, putDictData } from '@/api/dictdata'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    roleId: {
        type: String,
        required: false
    },
    dictDataCode: {
        type: String,
        required: false
    }
})
const dialogTitle = ref('')

const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源

const formData = ref({
    dict_code: props.dictDataCode,
    label: '',
    value: '',
    css_class: '',
    list_class: '',
    remark: '',
    list_order: 1,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    label: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入数据标签'
        }
    ],
    value: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入数据键值'
        }
    ],
    list_order: [
        {
            required: true
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
const treeRef = ref(null)

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    dialogTitle.value = ''
    formRef.value && formRef.value.resetFields()
    treeRef.value && treeRef.value.setCheckedKeys([], false)
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.roleId !== '') {
        await doPutDict()
    } else {
        await doAddDict()
    }
}

const classOptions = [
    { label: '默认(default)', value: 'default' },
    { label: '主要(primary)', value: 'primary' },
    { label: '成功(success)', value: 'success' },
    { label: '信息(info)', value: 'info' },
    { label: '警告(warning)', value: 'warning' },
    { label: '危险(danger)', value: 'danger' }
]

// 修改
const doPutDict = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await putDictData(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加
const doAddDict = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await addDictData(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取字典详情
const doGetDictDetail = async () => {
    const data = await getDictDataDetail(props.roleId)
    formRef.value.resetFields()
    formData.value = data
}

// 只有roleId有的时候，才会去请求数据

watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.roleId) {
            doGetDictDetail()
        } else {
            formData.value = {
                dict_code: props.dictDataCode,
                label: '',
                value: '',
                css_class: '',
                list_class: '',
                remark: '',
                list_order: 1,
                status: 1,
                visible: 1
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
